/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Meta_Ogtitle1Inputs */

const ja_careers_meta_ogtitle1 = /** @type {(inputs: Careers_Meta_Ogtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`株式会社プレイブレーン - 採用情報`)
};

const en_careers_meta_ogtitle1 = /** @type {(inputs: Careers_Meta_Ogtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN - Join Us`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN - Join Us" |
*
* @param {Careers_Meta_Ogtitle1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const careers_meta_ogtitle1 = /** @type {((inputs?: Careers_Meta_Ogtitle1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Meta_Ogtitle1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_meta_ogtitle1(inputs)
	return en_careers_meta_ogtitle1(inputs)
});
export { careers_meta_ogtitle1 as "careers_meta_ogTitle" }